module.exports = __webpack_public_path__ + "static/media/pen.2c307524.svg";